// Platform detection — Tauri vs browser.
//
// The desktop UI ships in two runtimes: the Tauri native shell and a plain
// browser (PWA). Every code path that touched `window.__TAURI__` directly
// before the shim now routes through `isTauri()` / `getPlatform()`.

export function isTauri(): boolean {
	return typeof window !== 'undefined' && '__TAURI__' in window;
}

export type Platform = 'tauri' | 'web';

export function getPlatform(): Platform {
	return isTauri() ? 'tauri' : 'web';
}
